import React, {useEffect, useState} from 'react';
import './index.scss';
import {Helmet} from 'react-helmet';
import DashboardHeader from '../../components/DashboardHeader';
import Wrapper from '../../components/Wrapper';
import {useDispatch, useSelector} from 'react-redux';
import {customDetailsRows} from './customInspectionsDetailsUtils';
import {useNavigate, useParams} from 'react-router-dom';
import {
  useGetCustomInspectionsDetailsQuery,
  useLazyGetCustomFormDetailsAgenciesEquipmentsQuery,
  useLazyGetCustomFormDetailsAgenciesQuery,
  useLazyGetCustomInspectionsDetailsQuery,
} from '../../store/builder/inspections.api';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {setLoader} from '../../store/builder/reducer';
import useLoader from '../../global/UseLoadingHandler';
import {useTranslation} from '../../hooks/useTranslation';

const CustomInspectionsDetails = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [rows, setRows] = useState([]);
  const [inspectionDetailsModal, setInspectionDetailsModal] = useState(false);
  const [chosenAgency, setChosenAgency] = useState(null);
  const [agencyEquipmentsList, setAgencyEquipmentsList] = useState([]);

  const [
    getCustomsDetails,
    {
      data: getCustomsDetailsData,
      isError: getCustomsDetailsIsError,
      isFetching: getCustomsDetailsIsLoading,
      error: getCustomsDetailsError,
      isSuccess: getCustomsDetailsIsSuccess,
    },
  ] = useLazyGetCustomFormDetailsAgenciesQuery();

  const [
    getDetailsAgencies,
    {
      data: getDetailsAgenciesData,
      isError: getDetailsAgenciesIsError,
      isFetching: getDetailsAgenciesIsLoading,
      error: getDetailsAgenciesError,
      isSuccess: getDetailsAgenciesIsSuccess,
    },
  ] = useLazyGetCustomFormDetailsAgenciesEquipmentsQuery();

  useLoader([getCustomsDetailsIsLoading, getDetailsAgenciesIsLoading]);

  const [errorHandler, setErrorHandler] = useErrorHandler([
    getCustomsDetailsError,
    getDetailsAgenciesError,
  ]);

  useEffect(() => {
    getCustomsDetails(params?.id);
  }, []);

  useEffect(() => {
    if (inspectionDetailsModal) {
      if (chosenAgency !== null && chosenAgency !== undefined) {
        getDetailsAgencies({form_id: params?.id, agency_id: chosenAgency});
      }
    }
  }, [chosenAgency, inspectionDetailsModal]);

  useEffect(() => {
    if (getCustomsDetailsData) {
      setRows(getCustomsDetailsData);
    } else {
      setRows([]);
    }

    if (getDetailsAgenciesData?.items?.length > 0) {
      setAgencyEquipmentsList(getDetailsAgenciesData?.items);
    } else {
      setAgencyEquipmentsList([]);
    }
  }, [getCustomsDetailsData, getDetailsAgenciesData]);

  const renderInspectionDetailsModal = () => {
    return (
      <div className='modal regions'>
        <div className='modal__regions small'>
          <div className='modal__regions-header'>
            <p className='modal__regions-title'>
              {t('customInspectionsDetails.modals.equipmentTitle')}({getDetailsAgenciesData?.items?.length})
            </p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => {
                setInspectionDetailsModal(false);
                setAgencyEquipmentsList([]);
              }}
            />
          </div>
          <div className='modal__regions-body customInspections'>
            <div className='modal__regions-list all-items equipments'>
              <div className='customDetail__table'>
                <div className='customDetail__table-header smallHeader white'>
                  <div className='customDetail__table-th smallTh'>
                    {t('customInspectionsDetails.tableHeaders.equipmentType')}
                  </div>
                  <div className='customDetail__table-th smallTh'>---</div>
                </div>
                <div className='customDetail__table-header smallHeader'>
                  <div className='customDetail__table-th smallTh'>
                    {t('customInspectionsDetails.tableHeaders.equipmentName')}
                  </div>
                </div>
                <div className='customDetail__table-body equipments'>
                  {agencyEquipmentsList?.length > 0 ? (
                    agencyEquipmentsList?.map((row, index) => (
                      <div
                        key={index}
                        style={{position: 'relative'}}
                        className={`customDetail__table-row`}
                        onClick={() => setInspectionDetailsModal(true)}
                      >
                        <div className='customDetail__table-bodyTh'>{row}</div>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '205px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingTop: 100,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                        }}
                      >
                        <div className='expired__box-img' style={{margin: '0'}}>
                          <img src='/assets/no-data.svg' alt='no-data' />
                        </div>
                        <p className='no-payment-text'>{t('customInspectionsDetails.messages.noData')}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className='modal__bg'
          onClick={() => {
            setInspectionDetailsModal(false);
            setAgencyEquipmentsList([]);
          }}
        ></div>
      </div>
    );
  };

  return (
    <Wrapper>
      <Helmet>
        <title>{t('customInspectionsDetails.pageTitle')}</title>
      </Helmet>
      <DashboardHeader
        title={t('customInspectionsDetails.title')}
        type='custom-inspections-details'
      />
      {inspectionDetailsModal && renderInspectionDetailsModal()}
      <div className='customDetail'>
        <div className='customDetail__content'>
          <div className='customDetail__table'>
            <div className='customDetail__table-header'>
              <div className='customDetail__table-th'>{t('customInspectionsDetails.tableHeaders.fboName')}</div>
              <div className='customDetail__table-th'>{t('customInspectionsDetails.tableHeaders.region')}</div>
              <div className='customDetail__table-th'>{t('customInspectionsDetails.tableHeaders.status')}</div>
              <div className='customDetail__table-th'>{t('customInspectionsDetails.tableHeaders.count')}</div>
            </div>
            <div className='customDetail__table-body'>
              {rows?.length > 0 ? (
                rows?.map((row, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setInspectionDetailsModal(true);
                      setChosenAgency(row?.agency_id);
                    }}
                    style={{position: 'relative'}}
                    className={`customDetail__table-row`}
                  >
                    <div className='customDetail__table-bodyTh'>
                      {row?.agency_title}
                    </div>
                    <div className='customDetail__table-bodyTh'>
                      {row?.agency_state ? row?.agency_state : '---'}
                    </div>
                    <div className='customDetail__table-bodyTh'>
                      {row?.assigned ? (
                        <button className='custom-button transparentGreen small'>
                          {t('customInspectionsDetails.actions.assigned')}
                        </button>
                      ) : (
                        <button className='custom-button transparentRed small'>
                          {t('customInspectionsDetails.actions.notAssigned')}
                        </button>
                      )}
                    </div>
                    <div className='customDetail__table-bodyTh'>
                      {row?.count ? row?.count : t('customInspectionsDetails.messages.notAvailable')}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: '205px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '100px 0px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <div className='expired__box-img' style={{margin: '0'}}>
                      <img src='/assets/no-data.svg' alt='no-data' />
                    </div>
                    <p className='no-payment-text'>{t('customInspectionsDetails.messages.noData')}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default CustomInspectionsDetails;
